<template>
  <q-dialog v-model="Show" persistent @hide="CerrarModal">
    <q-card style="width: 550px; max-width: 90vw;" class="rounded-borders shadow-4">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon :name="Nuevo ? 'add_circle' : 'edit'" class="q-mr-sm" size="sm" />
          {{ Nuevo ? 'Nuevo Servicio Global' : 'Editar Servicio' }}
        </div>
        <q-btn icon="close" flat round dense v-close-popup @click="CerrarModal" />
      </q-card-section>

      <q-card-section class="q-pa-md q-gutter-y-md">
        <q-form @submit.prevent="Guardar" class="q-gutter-y-md">
          <div class="row q-col-gutter-md">
            <div v-if="!Nuevo" class="col-12 col-sm-4">
              <q-input
                v-model="Form.idServicio"
                label="ID Servicio"
                outlined
                dense
                disable
              />
            </div>
            <div :class="Nuevo ? 'col-12' : 'col-12 col-sm-8'">
              <q-input
                v-model="Form.descripcion"
                label="Descripción del Servicio *"
                outlined
                dense
                :rules="[val => !!val || 'Descripción requerida']"
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="Form.alias"
                label="Alias / Grupo Breve"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model.number="Form.diasaviso"
                type="number"
                label="Días de Aviso *"
                outlined
                dense
                :rules="[val => val !== null && val !== '' || 'Días de aviso requeridos']"
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-select
                v-model="Form.estado"
                :options="[
                  { label: 'Vigente / Activo', value: 'V' },
                  { label: 'Anulado / Inactivo', value: 'A' }
                ]"
                option-value="value"
                option-label="label"
                emit-value
                map-options
                label="Estado *"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-select
                v-model="Form.obligatorio"
                :options="[
                  { label: 'SÍ', value: 'SI' },
                  { label: 'NO', value: 'NO' }
                ]"
                option-value="value"
                option-label="label"
                emit-value
                map-options
                label="Obligatorio *"
                outlined
                dense
              />
            </div>
          </div>

          <q-input
            v-model="Form.mensajeVencimiento"
            label="Mensaje al Vencer"
            outlined
            dense
            type="textarea"
            rows="2"
          />

          <q-input
            v-model="Form.mensajeAdvertencia"
            label="Mensaje de Advertencia"
            outlined
            dense
            type="textarea"
            rows="2"
          />

          <div class="row justify-end q-gutter-sm q-pt-sm">
            <q-btn
              flat
              label="Cancelar"
              color="grey-7"
              no-caps
              @click="CerrarModal"
            />
            <q-btn
              type="submit"
              color="primary"
              label="Guardar Servicio"
              icon="save"
              unelevated
              no-caps
              :loading="isLoading"
              class="text-weight-bold"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "ServicioNuevoModal",
  props: {
    DialogServicio: {
      type: Boolean,
      required: true,
      default: false,
    },
    Servicio: {
      type: Object,
      default: () => null,
    },
    Nuevo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      Show: this.DialogServicio,
      Form: {
        idServicio: "",
        descripcion: "",
        alias: "",
        diasaviso: 5,
        estado: "V",
        obligatorio: "NO",
        mensajeVencimiento: "",
        mensajeAdvertencia: "",
      },
    };
  },
  watch: {
    DialogServicio(val) {
      this.Show = val;
      if (val) {
        if (this.Servicio) {
          this.Form = { ...this.Servicio };
        } else {
          this.ResetForm();
        }
      }
    },
  },
  methods: {
    ResetForm() {
      this.Form = {
        idServicio: "",
        descripcion: "",
        alias: "",
        diasaviso: 5,
        estado: "V",
        obligatorio: "NO",
        mensajeVencimiento: "",
        mensajeAdvertencia: "",
      };
    },
    Guardar() {
      let me = this;
      me.isLoading = true;
      const endpoint = me.Nuevo ? "ApiWeb/ServicioAgregar.php" : "ApiWeb/ServicioEditar.php";

      axios
        .post(endpoint, me.Form)
        .then((response) => {
          if (response.data && response.data.error) {
            me.notificar(response.data.mensaje || "Error al guardar servicio", "warning");
          } else {
            const msg = (response.data && response.data.mensaje) || "Servicio guardado exitosamente";
            me.notificar(msg, "positive");
            me.$emit("GuardadoExitoso");
            me.CerrarModal();
          }
        })
        .catch((error) => {
          console.error("Error Guardar Servicio:", error);
          me.notificar("Error de conexión al guardar servicio", "negative");
        })
        .finally(() => {
          me.isLoading = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000,
        });
      } else {
        alert(msg);
      }
    },
    CerrarModal() {
      this.Show = false;
      this.$emit("CerrarModal");
    },
  },
};
</script>
